import MuiContainer, {
  ContainerProps as MuiContainerProps,
} from '@material-ui/core/Container';
import styled from 'styled-components';

import { styledSystem, StyledSystemProps } from '../styledSystem';

interface ContainerProps
  extends Omit<MuiContainerProps, 'color'>,
    Omit<StyledSystemProps, 'maxWidth'> {}

export const Container = styled(({ color, ...props }: ContainerProps) => (
  <MuiContainer fixed {...props} />
))`
  &&& {
    ${styledSystem}
  }
`;
